import { render, staticRenderFns } from "./customDialog.vue?vue&type=template&id=42a571b0&scoped=true&"
import script from "./customDialog.vue?vue&type=script&lang=js&"
export * from "./customDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a571b0",
  null
  
)

export default component.exports